import { useQuery } from '@tanstack/react-query';
import { activitySphereApi } from '../activitySphereApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetActivitySphere = () => {
  return useQuery({
    queryKey: [QueryKey.GET_ACTIVITY_SPHERE],
    queryFn: () =>
      activitySphereApi.getActivitySpheres({
        filter: {},
        paginate: PaginateType.NONE,
      }),
  });
};
